<template>
  <div class="right_festbtn">
    <div class="marb_80 marb_pcs_30 marb_pad_10">
      <a href="https://www.cgmh.org.tw/" class="lang" target="_blank" title="繁中"><span></span>
        <p>繁中</p>
      </a>
    </div>
    <div class="marb_30 marb_pad_10 org_color">
      <template v-for="data in orangeData">
        <a target="_blank" :href="data.Link" :class="data.Class"><span></span><p v-text="data.Name"></p></a>
      </template>
    </div>
    <div class="wwbk marb_30 marb_pad_10 green">
      <template v-for="data in greenData">
        <a target="_blank" :href="data.Link" :class="data.Class"><span></span><p v-text="data.Name"></p></a>
      </template>
    </div>
    <div class="wwbk marb_pad_10">
      <template v-for="data in noneData">
        <a target="_blank" :href="data.Link" :class="data.Class"><span></span><p v-text="data.Name"></p></a>
      </template>
    </div>
    <div class="contact">
      <a :href="`${serverRoot}/${contactUrl}`" class="contact_icon">
        <span></span>
        <p>CONTACT</p>
      </a>
    </div>
  </div>
</template>

<script>
    import Constants from "../Constants";
    import utils from "../Utils";
    import _ from "lodash";
    export default {
        name: "FastLink",
        props: {
        },
        mixins: [utils],
        data() {
            return {
              serverRoot          :Constants.serverRoot,
              url:`${Constants.serverUrl}/api/slide-link`,
              slideLinkList:[],
              contactUrl:"javascript:;"
            };
        },
        created() {
        },
        mounted() {
          const _this = this
          _this.fetchData(this.url, '', 'slideLinkList','pageData.contentData', function (extraParams, response) {
            _this.slideLinkList = _.get(response, 'data.Value.pageData.contentData.slideLinkList', [])
            _this.contactUrl    = _.get(response, 'data.Value.pageData.contentData.contactUrl'   , 'javascript:;')
          })
        },
        methods: {
        },
        computed: {
          orangeData() {
            return _.filter(this.slideLinkList , function (o) {
              return o.GroupName === 'org_color';
            });
          },
          greenData() {
            return _.filter(this.slideLinkList, function (o) {
              return o.GroupName === 'green';
            });
          },
          noneData() {
            return _.filter(this.slideLinkList, function (o) {
              return o.GroupName === '';
            });
          },
        },
    };
</script>
